<!--MyTestsPage.vue
    Offers cart similar functionality for the My Tests page
    by Guy E. White <guw968@g.harvard.edu>

    Modified from CartPage.vue from course instructor Susan Buck:
    https://github.com/susanBuck/e28/tree/master/zipfoods
-->

<template>
    <div id='mytests-page'>
        <h1>My Tests</h1>

        <div v-if='items.length == 0'>You have no tests selected yet.</div>
        <ul data-test='mytests-contents' class='cleanList' v-if='tests'>
            <li v-for='item in items' :key='item.slug'>
                {{ getProductDetails(item.slug).testName }}
                <button data-test='remove-from-mytests-button' @click='removeFromMyTests(item.slug, item.quantity)'>Remove</button>
            </li>
        </ul>
    </div>
</template>

<script>
import * as app from '@/common/app.js';

export default {
    data: function() {
        return {
            items: [],
            mytests: null,
        };
    },
    mounted() {

        // Making My Tests instant a data property so we can use it later in a removeFromMyTests method
        this.mytests = new app.MyTests();
        this.items = this.mytests.getItems();
    },
    methods: {
        getProductDetails(slug) {
            for (let key of Object.keys(this.tests)) {
                if (this.tests[key].slug == slug) {
                    return this.tests[key];
                }
            }
        },
        removeFromMyTests(slug, quantity) {
            this.mytests.remove(slug);

            // Update State Management
            this.$store.commit('updateMyTestsCount', -quantity);
        }
    },
    computed: {
        tests: function() {
            return this.$store.state.products;
        }
    }
};
</script>
